(() => {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function getCartIcon() {
    return document.querySelector('#cart-icon-bubble');
  }

  function getProductImage(sourceElement) {
    const container =
      sourceElement?.closest('.card-wrapper') ||
      sourceElement?.closest('product-info') ||
      sourceElement?.closest('quick-add-modal') ||
      sourceElement?.closest('section');

    return container?.querySelector('img');
  }

  function showAddedToast(cartIcon) {
    const existingToast = document.querySelector('.cart-added-toast');
    if (existingToast) existingToast.remove();

    const rect = cartIcon.getBoundingClientRect();
    const toast = document.createElement('div');

    toast.className = 'cart-added-toast';
    toast.textContent = 'Added to cart';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');

    toast.style.top = `${rect.bottom + 10}px`;
    toast.style.right = `${Math.max(12, window.innerWidth - rect.right)}px`;

    document.body.appendChild(toast);

    setTimeout(() => {
      toast.classList.add('cart-added-toast--hide');
      setTimeout(() => toast.remove(), 250);
    }, 1300);
  }

  function bumpCartIcon(cartIcon) {
    cartIcon.classList.remove('cart-bump');
    void cartIcon.offsetWidth;
    cartIcon.classList.add('cart-bump');
  }

  function flyToCart(sourceElement, cartIcon) {
    if (prefersReducedMotion) return;

    const image = getProductImage(sourceElement);
    const startSource = image || sourceElement;

    if (!startSource || !cartIcon) return;

    const startRect = startSource.getBoundingClientRect();
    const endRect = cartIcon.getBoundingClientRect();

    const flyer = document.createElement('div');
    flyer.className = 'cart-flyer';

    if (image?.src) {
      const flyerImage = document.createElement('img');
      flyerImage.src = image.src;
      flyerImage.alt = '';
      flyer.appendChild(flyerImage);
    } else {
      flyer.classList.add('cart-flyer--dot');
      flyer.textContent = '+';
    }

    const size = Math.min(72, Math.max(44, startRect.width * 0.35));

    flyer.style.width = `${size}px`;
    flyer.style.height = `${size}px`;
    flyer.style.left = `${startRect.left + startRect.width / 2 - size / 2}px`;
    flyer.style.top = `${startRect.top + startRect.height / 2 - size / 2}px`;

    document.body.appendChild(flyer);

    const deltaX = endRect.left + endRect.width / 2 - (startRect.left + startRect.width / 2);
    const deltaY = endRect.top + endRect.height / 2 - (startRect.top + startRect.height / 2);

    const animation = flyer.animate(
      [
        {
          transform: 'translate3d(0, 0, 0) scale(1)',
          opacity: 0.95,
        },
        {
          transform: `translate3d(${deltaX * 0.55}px, ${deltaY * 0.75 - 24}px, 0) scale(0.72)`,
          opacity: 0.8,
        },
        {
          transform: `translate3d(${deltaX}px, ${deltaY}px, 0) scale(0.18)`,
          opacity: 0,
        },
      ],
      {
        duration: 650,
        easing: 'cubic-bezier(.2,.8,.2,1)',
      }
    );

    animation.onfinish = () => flyer.remove();
  }

  window.addEventListener('dawn:cart-added', (event) => {
    const cartIcon = getCartIcon();
    if (!cartIcon) return;

    flyToCart(event.detail?.sourceElement, cartIcon);
    bumpCartIcon(cartIcon);
    showAddedToast(cartIcon);
  });
})();
